var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',{attrs:{"justify":"space-between"}},[_c('router-link',{attrs:{"to":_vm.link}},[_c('v-btn',{attrs:{"large":"","text-align":"center"}},[_vm._v(_vm._s(_vm.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }